export const CEREMONY_SITE_ID = "ceremy";
export const CEREMONY_RESERVATION_SITE_ID = "ceremy/reservation";

export const first = [
    {
        "SiteId": 94967,
        "UpdatedTime": "2021-09-17T18:01:21",
        "ResultId": 199827,
        "Ver": 1,
        "Title": "",
        "Body": "",
        "Status": 100,
        "Manager": 4,
        "Owner": 4,
        "Locked": false,
        "Comments": "[]",
        "Creator": 4,
        "Updator": 4,
        "CreatedTime": "2021-09-17T18:01:19",
        "ItemTitle": "タイトル無し",
        "ApiVersion": 1.000,
        "ClassA": "会場３",
        "NumA": 10.0000,
        "CheckA": true
    },
    {
        "SiteId": 94967,
        "UpdatedTime": "2021-09-17T17:58:37",
        "ResultId": 95001,
        "Ver": 3,
        "Title": "",
        "Body": "",
        "Status": 0,
        "Manager": 2,
        "Owner": 2,
        "Locked": false,
        "Comments": "[]",
        "Creator": 4,
        "Updator": 4,
        "CreatedTime": "2021-09-14T20:02:00",
        "ItemTitle": "タイトル無し",
        "ApiVersion": 1.000,
        "ClassA": "会場２",
        "NumA": 20.0000,
        "CheckA": true
    },
    {
        "SiteId": 94967,
        "UpdatedTime": "2021-09-14T20:02:00",
        "ResultId": 95003,
        "Ver": 1,
        "Title": "",
        "Body": "",
        "Status": 0,
        "Manager": 2,
        "Owner": 2,
        "Locked": false,
        "Comments": "[]",
        "Creator": 4,
        "Updator": 4,
        "CreatedTime": "2021-09-14T20:02:00",
        "ItemTitle": "タイトル無し",
        "ApiVersion": 1.000,
        "ClassA": "会場１",
        "NumA": 30.0000,
        "CheckA": false
    },
    {
        "SiteId": 94967,
        "UpdatedTime": "2021-09-14T20:02:00",
        "ResultId": 95002,
        "Ver": 1,
        "Title": "",
        "Body": "",
        "Status": 0,
        "Manager": 2,
        "Owner": 2,
        "Locked": false,
        "Comments": "[]",
        "Creator": 4,
        "Updator": 4,
        "CreatedTime": "2021-09-14T20:02:00",
        "ItemTitle": "タイトル無し",
        "ApiVersion": 1.000,
        "ClassA": "大会場",
        "NumA": 80.0000,
        "CheckA": false
    }
];

export const second = [
    {
        "SiteId": 94966,
        "UpdatedTime": "2021-09-17T17:57:31",
        "ResultId": 199819,
        "Ver": 2,
        "Title": "",
        "Body": "",
        "Status": 100,
        "Manager": 4,
        "Owner": 4,
        "Locked": false,
        "Comments": "[]",
        "Creator": 4,
        "Updator": 4,
        "CreatedTime": "2021-09-14T21:45:38",
        "ItemTitle": "タイトル無し",
        "ApiVersion": 1.000,
        "ClassA": "",
        "ClassB": "",
        "ClassC": "95003",
        "ClassD": "",
        "ClassE": "小池",
        "ClassF": "052-111-1233",
        "DateA": "2021-09-14T00:00:00",
        "DateB": "2021-09-14T15:00:00",
        "DateC": "2021-09-14T17:30:00",
        "DescriptionA": "[md]\n|時間|予約済|時間|予約済|時間|予約済|\n|:-:|:-:|:-:|:-:|:-:|:-:|\n|9:00～9:30|予約済|13:00～13:30|予約済|17:00～17:30||\n|9:30～10:00|予約済|13:30～14:00|予約済|17:30～18:00||\n|10:00～10:30|予約済|14:00～14:30||18:00～18:30||\n|10:30～11:00|予約済|14:30～15:00||18:30～19:00||\n|11:00～11:30|予約済|15:00～15:30||19:00～19:30||\n|11:30～12:00|予約済|15:30～16:00||19:30～20:00||\n|12:00～12:30||16:00～16:30||20:00～20:30||\n|12:30～13:00||16:30～17:00||20:30～21:00||\n"
    },
    {
        "SiteId": 94966,
        "UpdatedTime": "2021-09-17T17:57:19",
        "ResultId": 199820,
        "Ver": 2,
        "Title": "",
        "Body": "",
        "Status": 100,
        "Manager": 4,
        "Owner": 4,
        "Locked": false,
        "Comments": "[]",
        "Creator": 4,
        "Updator": 4,
        "CreatedTime": "2021-09-14T21:45:38",
        "ItemTitle": "タイトル無し",
        "ApiVersion": 1.000,
        "ClassA": "",
        "ClassB": "",
        "ClassC": "95003",
        "ClassD": "",
        "ClassE": "",
        "ClassF": "",
        "DateA": "2021-09-14T00:00:00",
        "DateB": "2021-09-14T13:00:00",
        "DateC": "2021-09-14T14:00:00",
        "DescriptionA": "[md]\n|時間|予約済|時間|予約済|時間|予約済|\n|:-:|:-:|:-:|:-:|:-:|:-:|\n|9:00～9:30|予約済|13:00～13:30||17:00～17:30||\n|9:30～10:00|予約済|13:30～14:00||17:30～18:00||\n|10:00～10:30|予約済|14:00～14:30||18:00～18:30||\n|10:30～11:00|予約済|14:30～15:00||18:30～19:00||\n|11:00～11:30|予約済|15:00～15:30||19:00～19:30||\n|11:30～12:00|予約済|15:30～16:00||19:30～20:00||\n|12:00～12:30||16:00～16:30||20:00～20:30||\n|12:30～13:00||16:30～17:00||20:30～21:00||\n"
    },
    {
        "SiteId": 94966,
        "UpdatedTime": "2021-09-17T17:56:45",
        "ResultId": 199822,
        "Ver": 2,
        "Title": "",
        "Body": "",
        "Status": 100,
        "Manager": 4,
        "Owner": 4,
        "Locked": false,
        "Comments": "[]",
        "Creator": 4,
        "Updator": 4,
        "CreatedTime": "2021-09-14T21:45:38",
        "ItemTitle": "タイトル無し",
        "ApiVersion": 1.000,
        "ClassA": "",
        "ClassB": "",
        "ClassC": "95003",
        "ClassD": "",
        "ClassE": "",
        "ClassF": "",
        "DateA": "2021-09-14T00:00:00",
        "DateB": "2021-09-14T09:00:00",
        "DateC": "2021-09-14T12:00:00",
        "DescriptionA": "[md]\n|時間|予約済|時間|予約済|時間|予約済|\n|:-:|:-:|:-:|:-:|:-:|:-:|\n|9:00～9:30||13:00～13:30||17:00～17:30||\n|9:30～10:00||13:30～14:00||17:30～18:00||\n|10:00～10:30||14:00～14:30||18:00～18:30||\n|10:30～11:00||14:30～15:00||18:30～19:00||\n|11:00～11:30||15:00～15:30||19:00～19:30||\n|11:30～12:00||15:30～16:00||19:30～20:00||\n|12:00～12:30||16:00～16:30||20:00～20:30||\n|12:30～13:00||16:30～17:00||20:30～21:00||\n"
    },
    {
        "SiteId": 94966,
        "UpdatedTime": "2021-09-17T17:56:22",
        "ResultId": 199823,
        "Ver": 2,
        "Title": "",
        "Body": "",
        "Status": 100,
        "Manager": 4,
        "Owner": 4,
        "Locked": false,
        "Comments": "[]",
        "Creator": 4,
        "Updator": 4,
        "CreatedTime": "2021-09-14T21:45:38",
        "ItemTitle": "タイトル無し",
        "ApiVersion": 1.000,
        "ClassA": "",
        "ClassB": "",
        "ClassC": "95002",
        "ClassD": "",
        "ClassE": "試験太郎",
        "ClassF": "052-791-0998",
        "DateA": "2021-09-14T00:00:00",
        "DateB": "2021-09-14T09:00:00",
        "DateC": "2021-09-14T12:00:00",
        "DescriptionA": "[md]\n|時間|予約済|時間|予約済|時間|予約済|\n|:-:|:-:|:-:|:-:|:-:|:-:|\n|9:00～9:30|予約済|13:00～13:30|予約済|17:00～17:30||\n|9:30～10:00|予約済|13:30～14:00|予約済|17:30～18:00||\n|10:00～10:30|予約済|14:00～14:30||18:00～18:30||\n|10:30～11:00|予約済|14:30～15:00||18:30～19:00||\n|11:00～11:30|予約済|15:00～15:30||19:00～19:30||\n|11:30～12:00|予約済|15:30～16:00||19:30～20:00||\n|12:00～12:30|予約済|16:00～16:30||20:00～20:30||\n|12:30～13:00|予約済|16:30～17:00||20:30～21:00||\n"
    },
    {
        "SiteId": 94966,
        "UpdatedTime": "2021-09-17T17:55:43",
        "ResultId": 199824,
        "Ver": 2,
        "Title": "",
        "Body": "",
        "Status": 100,
        "Manager": 4,
        "Owner": 4,
        "Locked": false,
        "Comments": "[]",
        "Creator": 4,
        "Updator": 4,
        "CreatedTime": "2021-09-14T21:45:38",
        "ItemTitle": "タイトル無し",
        "ApiVersion": 1.000,
        "ClassA": "00001",
        "ClassB": "141044",
        "ClassC": "95002",
        "ClassD": "0572-23-6305",
        "ClassE": "",
        "ClassF": "",
        "DateA": "2021-09-10T00:00:00",
        "DateB": "2021-09-10T17:00:00",
        "DateC": "2021-09-10T18:00:00",
        "DescriptionA": "[md]\n|時間|予約済|時間|予約済|時間|予約済|\n|:-:|:-:|:-:|:-:|:-:|:-:|\n|9:00～9:30|予約済|13:00～13:30|予約済|17:00～17:30||\n|9:30～10:00|予約済|13:30～14:00|予約済|17:30～18:00||\n|10:00～10:30|予約済|14:00～14:30||18:00～18:30||\n|10:30～11:00|予約済|14:30～15:00||18:30～19:00||\n|11:00～11:30|予約済|15:00～15:30||19:00～19:30||\n|11:30～12:00|予約済|15:30～16:00||19:30～20:00||\n|12:00～12:30|予約済|16:00～16:30||20:00～20:30||\n|12:30～13:00|予約済|16:30～17:00||20:30～21:00||\n"
    },
    {
        "SiteId": 94966,
        "UpdatedTime": "2021-09-17T17:54:48",
        "ResultId": 199825,
        "Ver": 2,
        "Title": "",
        "Body": "",
        "Status": 100,
        "Manager": 4,
        "Owner": 4,
        "Locked": false,
        "Comments": "[]",
        "Creator": 4,
        "Updator": 4,
        "CreatedTime": "2021-09-14T21:45:38",
        "ItemTitle": "タイトル無し",
        "ApiVersion": 1.000,
        "ClassA": "",
        "ClassB": "",
        "ClassC": "95002",
        "ClassD": "",
        "ClassE": "試験太郎",
        "ClassF": "052-111-1233",
        "DateA": "2021-09-10T00:00:00",
        "DateB": "2021-09-10T09:00:00",
        "DateC": "2021-09-10T10:00:00",
        "DescriptionA": "[md]\n|時間|予約済|時間|予約済|時間|予約済|\n|:-:|:-:|:-:|:-:|:-:|:-:|\n|9:00～9:30|予約済|13:00～13:30|予約済|17:00～17:30||\n|9:30～10:00|予約済|13:30～14:00|予約済|17:30～18:00||\n|10:00～10:30|予約済|14:00～14:30||18:00～18:30||\n|10:30～11:00|予約済|14:30～15:00||18:30～19:00||\n|11:00～11:30|予約済|15:00～15:30||19:00～19:30||\n|11:30～12:00|予約済|15:30～16:00||19:30～20:00||\n|12:00～12:30|予約済|16:00～16:30||20:00～20:30||\n|12:30～13:00|予約済|16:30～17:00||20:30～21:00||\n"
    },
    {
        "SiteId": 94966,
        "UpdatedTime": "2021-09-15T13:57:28",
        "ResultId": 199826,
        "Ver": 1,
        "Title": "",
        "Body": "",
        "Status": 100,
        "Manager": 4,
        "Owner": 4,
        "Locked": false,
        "Comments": "[]",
        "Creator": 4,
        "Updator": 4,
        "CreatedTime": "2021-09-15T13:57:25",
        "ItemTitle": "タイトル無し",
        "ApiVersion": 1.000,
        "ClassA": "",
        "ClassB": "",
        "ClassC": "95002",
        "ClassD": "",
        "ClassE": "試験１",
        "ClassF": "",
        "DateA": "2021-09-15T00:00:00",
        "DateB": "2021-09-15T09:00:00",
        "DateC": "2021-09-15T14:00:00",
        "DescriptionA": "[md]\n|時間|予約済|時間|予約済|時間|予約済|\n|:-:|:-:|:-:|:-:|:-:|:-:|\n|9:00～9:30||13:00～13:30||17:00～17:30||\n|9:30～10:00||13:30～14:00||17:30～18:00||\n|10:00～10:30||14:00～14:30||18:00～18:30||\n|10:30～11:00||14:30～15:00||18:30～19:00||\n|11:00～11:30||15:00～15:30||19:00～19:30||\n|11:30～12:00||15:30～16:00||19:30～20:00||\n|12:00～12:30||16:00～16:30||20:00～20:30||\n|12:30～13:00||16:30～17:00||20:30～21:00||\n"
    }
];